import { EMAIL_SUBSCRIPTION } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { EmailSubscriptionDisplayType } from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import NoOptionField from './NoOptionField';
import once from 'transmute/once';
export default once(() => NoOptionField({
  filterFamily: EMAIL_SUBSCRIPTION,
  displayType: EmailSubscriptionDisplayType
}));